import { createSlice } from "@reduxjs/toolkit";
const initialValue = {
  user: null,
};

const AuthSlice = createSlice({
  name: "auth",
  initialState: initialValue,
  reducers: {
    logout: (state, action) => {
      return {
        ...state,
        user: null
      };
    },
    signin: (state, action) => {
      return {
        ...state,
        user: action.payload
      };
    },
  },
});

const { reducer } = AuthSlice;
export default reducer;
export const { signin, logout } = AuthSlice.actions;
